<template>
    <el-select
        v-model="value"
        @change="changeSelect"
        style="width: 140px"
        :disabled="disabled"
    >
        <el-option
                v-for="n in positionList"
                :key="n.id"
                :label="n.positionname"
                :value="String(n.id)"
        />
    </el-select>

<!--    <el-text type="primary" class="text-btn" @click="clickInsert">添加</el-text>-->

<!--    <el-text type="danger" class="text-btn" @click="clickDel">刪除</el-text>-->
</template>

<script setup>
    import {ref, onMounted, watch, toRef} from 'vue'
    import {useUserinfo} from "@/stores/userinfo";
    import companyApi from "@/request/companyApi";
    import myUtil from "@/util/util";

    const props = defineProps(['modelValue', "disabled"])
    const emits = defineEmits(['update:modelValue'])

    const loading = ref(false)
    const value = ref(null)

    const positionList = ref([])

    //響應機制的userinfo
    const userInfoRef = toRef(useUserinfo())

    function changeSelect(e){
        emits('update:modelValue', e)
    }

    watch(() => props.modelValue, (newValue, oldValue) => {
        value.value = newValue
    })

    function getCompanyPosition(){
        const request = companyApi.queryPosition
        const params = request.getParams()

        params.companycode = userInfoRef.value.companycode

        request.send(params, (res) => {
            if (res.code == 200){
                positionList.value = res.detail

                if (null != res.detail && res.detail.length > 0 && null == value.value){
                    value.value = String(res.detail[0].id)
                    changeSelect(value.value)
                }
            }else{
                myUtil.alertError(res.msg)
            }
        })

    }

    function clickInsert() {
        myUtil.prompt({
            title: "添加職位",
            message: "請輸入職位名稱",
            callback: insertPosition,
            pattern: /[\u4E00-\u9FA5A-Za-z0-9_]+$/,
            inputErrorMessage: "只能輸入字母、數字和下劃線"
        })
    }

    function clickDel() {
        myUtil.confirmWarning("確定刪除職位嗎？", () => {
            delPosition()
        })
    }

    function insertPosition(name) {
        loading.value = true
        const request = companyApi.addPosition
        const params = request.getParams()

        params.companycode = userInfoRef.value.companycode
        params.positionname = name

        request.send(params, (res) => {
            loading.value = false
            if (res.code == 200){
                myUtil.alertSuccess("添加成功")
                getCompanyPosition()
            }else{
                myUtil.alertError(res.msg)
            }
        })

    }

    function delPosition(){
        loading.value = true

        const request = companyApi.deletePosition
        const params = request.getParams()

        params.companycode = userInfoRef.value.companycode
        params.id = value.value

        request.send(params, (res) => {
            loading.value = false
            if (res.code == 200){
                myUtil.alertSuccess("刪除成功")
                getCompanyPosition()
            }else{
                myUtil.alertError(res.msg)
            }
        })
    }

    function getPositionObj(){
        let obj = null

        for (let i=0; i<positionList.value.length; i++){
            const temp = positionList.value[i]

            if (temp.id == value.value){
                obj = temp
                break
            }
        }

        return obj
    }

    defineExpose({
        getPositionObj
    })

    onMounted(() => {
        value.value = props.modelValue

        getCompanyPosition()
    })
</script>

<style scoped>
    .text-btn {
        margin-left: 10px;
        margin-right: 10px;
        cursor: pointer;
    }

    .text-btn:hover {
        text-decoration: underline;
    }
</style>